import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const DriverContactDetailsStyle = styled.div`
  .email-message {
    margin-top: ${theme.grid.spacing.s}px;
    padding: ${theme.grid.spacing.xs}px ${theme.grid.spacing.xs}px ${theme.grid.spacing.xs}px ${theme.grid.spacing.s}px;
  }

  .security-message svg {
    height: 40px;
    width: 40px;
  }

  .privacy-link {
    text-decoration: underline;
    cursor: pointer;
  }

  .driver-marketing-toggles {
    margin-top: ${theme.grid.spacing.base}px;
  }

  .marketing-error {
    margin-bottom: ${theme.grid.spacing.base}px;
  }

  @media (max-width: ${theme.grid.resolution.mobile.width}px) {
    .banner-message {
      width: 280px;
    }
    security-message svg {
      display: none;
    }
  }

  @media (min-width: ${theme.grid.resolution.mobile.width}px) {
    .question-container {
      &:not(:last-child) {
        margin-bottom: ${theme.grid.spacing.md}px;
      }
    }
  }
`
